import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '../common/avatar';
import AvatarImg from '../../../../public/images/nopicture.png';

const ButtonsTop = props => (
  <section className="module-filter top buttons-top">
    <div className="flex">
      <div className="title driver-name">
        <Avatar width={25} src={`${AvatarImg}`} />
        {props.driverName ? props.driverName.toUpperCase() : ""}
      </div>
      <section className="module-title">
        <h2>{props.language.summary.behaviour.title}</h2>
      </section>
    </div>
  </section>
);

export default ButtonsTop;



// WEBPACK FOOTER //
// ./source/client/components/driver_behavior/buttonsTop.jsx